module.exports = __webpack_public_path__ + "static/img/hotelbeds.4ae8278b.png";